<app-admin-appbar></app-admin-appbar>
<br />

<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
  <div class="d-flex flex-column">
    <label
      class="form-label small text-muted mb-1"
      for="admin_advisories_filter_published"
    >
      Published
    </label>
    <kendo-dropdownlist
      id="admin_advisories_filter_published"
      [defaultItem]="{ text: 'All', value: null }"
      textField="text"
      valueField="value"
      [data]="publishedOptions"
      [style]="{ width: '200px' }"
      (valueChange)="publishedChange($event)"
    ></kendo-dropdownlist>
  </div>
  <button
    kendoButton
    class="align-self-end"
    (click)="addAdvisory()"
    [svgIcon]="plusIcon"
    themeColor="primary"
  >
    Add Advisory
  </button>
</div>

<app-datatable
  [data-href]="datatableUrl"
  [columns]="datatableColumns"
  [useOData]="true"
  [initialFilters]="initialFilters"
  [clickableRows]="true"
  (rowClick)="editAdvisory($event)"
></app-datatable>
